import * as React from 'react';

export const useCarouselToggle = (itemsLength: number) => {
  const [activeItemIndex, setActiveItemIndex] = React.useState(0);

  const handlePrevClick = () => setActiveItemIndex((i) => (i === 0 ? itemsLength - 1 : i - 1));
  const handleNextClick = () => setActiveItemIndex((i) => (i >= itemsLength - 1 ? 0 : i + 1));

  return { activeItemIndex, handlePrevClick, handleNextClick, setActiveItemIndex };
};
